
import { defineComponent } from "vue";
import TextScrambler from "@/data/TextScrambler";

export default defineComponent({
  name: "MindGamesHeader",

  data() {
    return {
      mindScrambler: new TextScrambler("MiNd", 5000),
      gamesScrambler: new TextScrambler("GAmES", 5000),
    };
  },
  mounted() {
    if (!this.sessionStarted) {
      this.startScramble();
    }
  },

  computed: {
    sessionStarted(): boolean {
      return this.$store.state.sessionStarted;
    },
    isHome(): boolean {
      return this.$route.name === "Home";
    },
    transitionName() {
      return this.$store.state.transitionName;
    },
  },

  methods: {
    startScramble() {
      this.mindScrambler.start();
      this.gamesScrambler.start();
    },
  },
});
